var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoutes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5455 7.96259C19.4163 7.96259 20.1223 7.25665 20.1223 6.38584C20.1223 5.51502 19.4163 4.80908 18.5455 4.80908C17.6747 4.80908 16.9688 5.51502 16.9688 6.38584C16.9688 7.25665 17.6747 7.96259 18.5455 7.96259Z",
    stroke: "#EFF1F7",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.38549C22 7.84814 19.9668 10.317 19.0228 11.3958C18.7635 11.6863 18.3278 11.6863 18.0685 11.3958C17.1245 10.3274 15.0913 7.84814 15.0913 6.38549C15.0913 4.47679 16.6369 2.93115 18.5456 2.93115C20.4543 2.93115 22 4.47679 22 6.38549Z",
    stroke: "#EFF1F7",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02066 14.0828C8.29252 14.0828 9.32355 13.0518 9.32355 11.7799C9.32355 10.5081 8.29252 9.47705 7.02066 9.47705C5.74881 9.47705 4.71777 10.5081 4.71777 11.7799C4.71777 13.0518 5.74881 14.0828 7.02066 14.0828Z",
    stroke: "#EFF1F7",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0414 11.6555C12.0414 13.3048 10.2572 16.6243 8.81531 19.0413C8.00619 20.4002 6.03525 20.4002 5.22612 19.0413C3.78422 16.6243 2 13.3048 2 11.6555C2 8.88579 4.25102 6.63477 7.02072 6.63477C9.79041 6.63477 12.0414 8.88579 12.0414 11.6555Z",
    stroke: "#EFF1F7",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7552 11.6138C14.8319 11.6449 14.2095 12.7341 14.3859 13.647C14.5622 14.5598 15.2884 15.2652 16.056 15.7735C16.834 16.2818 17.695 16.6656 18.4004 17.2673C18.7427 17.5577 19.0539 17.9208 19.0954 18.3668C19.168 19.0204 18.6182 19.6013 17.9958 19.8191C17.3734 20.0266 16.6992 19.9643 16.0456 19.9228C14.3859 19.8087 12.7158 19.871 11.0664 20.0888",
    stroke: "#EFF1F7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutes);
export default __webpack_public_path__ + "static/media/routes.ccec8637.svg";
export { ForwardRef as ReactComponent };